declare var showdown: any;
declare var Prism: any;

class MDoc {
    private converter;
    private rootElement;
    private menuElement;
    private markdown: string = "";

    constructor(bodyElement: any, menuElement: any) {

        Prism.plugins.autoloader.languages_path = 'https://cdnjs.cloudflare.com/ajax/libs/prism/1.10.0/components/';
        Prism.plugins.customClass.prefix('prism--');

        this.converter = new showdown.Converter({
            ghCompatibleHeaderId: true,
            excludeTrailingPunctuationFromURLs: true,
            ghCodeBlocks: true,
            tasklists: true,
            openLinksInNewWindow: true,
            emoji: true,
            tables: true,
            simpleLineBreaks: true,
            omitExtraWLInCodeBlocks: true
        });
        this.rootElement = $(bodyElement);

        this.rootElement.empty();

        $(menuElement).empty();
        this.menuElement = $(`<aside class="menu"></aside>`);
        $(menuElement).append(this.menuElement);
    }

    refresh() {

        // Preprocess a few things
        let markdown = this.markdown.replace(/data-mdoc\s*=/g, `markdown="1" data-mdoc=`);

        let newHTML = this.converter.makeHtml(markdown);

        let markdownBlock = $(newHTML);

        let markupBlock = $(`<div class="doc-body"></div>`);
        let currentContentBlock;
        let currentBlockContainer;
        let currentMenuBlock;

        function createNewSection() {
            currentBlockContainer = $(`<div class="columns doc-container"></div>`);
            currentContentBlock = $(`<div class="column is-offset-2 is-6 doc-content content"></div>`);

            currentBlockContainer.append(currentContentBlock);
            markupBlock.append(currentBlockContainer);
        }

        markdownBlock.each((index, element) => {

            let jElement = $(element);
            let tagName = jElement.prop("tagName");
            let isHeader = /H\d/.test(tagName);
            let isSidebar = jElement.attr("data-mdoc") === "sidebar";

            if (!currentContentBlock || isHeader) {
                createNewSection();
            }

            if (isHeader) {

                let headerNumber = Number(tagName.slice(-1));

                jElement.addClass(`is-${headerNumber + 1}`);

                if (headerNumber === 1) {
                    this.menuElement.append(`<p class="menu-label"><a href="#${jElement.prop("id")}">${jElement.text()}</a></p>`);
                    currentMenuBlock = null;
                }
                else if (headerNumber <= 2) {
                    if (!currentMenuBlock) {
                        currentMenuBlock = $(`<ul class="menu-list"></ul>`);
                        this.menuElement.append(currentMenuBlock);
                    }

                    currentMenuBlock.append(`<li><a href="#${jElement.prop("id")}">${jElement.text()}</a></li>`);
                }
            }

            if (isSidebar) {
                let sidebarContainer = $(`<div class="column is-4 sidebar has-text-white section"></div>`);
                sidebarContainer.append(jElement);
                currentBlockContainer.append(sidebarContainer);

                createNewSection();
            }
            else {
                if (isHeader) {
                    currentContentBlock.append(`<a name="${jElement.prop("id")}"></a>`);
                }

                currentContentBlock.append(jElement);
            }
        });

        // Adjust tables
        markupBlock.find("table").addClass("table is-fullwidth");

        // Adjust headers
        markupBlock.find("h1, h2, h3, h4, h5, h6, h7, h8").addClass("title");

        // Highlight syntax
        Prism.highlightAllUnder(markupBlock.get(0));

        markupBlock.find("[data-mdoc='api-endpoint']").each((index, element) => {
            let jElement = $(element);
            let parts = jElement.text().split(" ");

            if(parts.length == 2)
            {
                let method = parts[0];
                let path = parts[1];
                let color;

                switch(method.toUpperCase())
                {
                    case "POST": color = "is-success"; break;
                    case "GET": color = "is-info"; break;
                    case "DELETE": color = "is-danger"; break;
                    default:
                    {
                        color = "is-primary";
                    }
                }

                jElement.replaceWith(`<div class="tags has-addons"><span class="tag ${color} is-medium">${method}</span><span class="tag is-medium">${path}</span></div>`);
            }
        });

        // Remove all the previous content
        this.rootElement.empty();
        this.rootElement.append(markupBlock);

        let hash = location.hash;
        location.hash = "#";
        location.hash = hash;
    }

    addMarkdownFromText(markdownString: string) {
        this.markdown += markdownString;
        this.refresh();
    }

    addMarkdownFromURL(url: string) {

        fetch(url).then((response) => {
            return response.text();
        }, (error) => {
            console.log(error);
        }).then((responseBody) => {
            this.addMarkdownFromText(responseBody as string);
        });
    }
}